




























import { defineComponent } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "GroupList",
  components: { ListItem },
  props: {
    groups: { type: Array as () => Group[] },
    itemClass: { type: String },
    groupLink: { type: Boolean, default: false },
  },
  methods: {
    getRouterLink(item: Group) {
      return this.$route.name === "manageGroups"
        ? { name: "manageGroupUsers", params: { groupId: item.id } }
        : undefined;
    },
    getPlurMemberCount(item: Group) {
      return item.memberCount === 1
        ? this.$t("{0} person", [item.memberCount])
        : this.$t("{0} people", [item.memberCount]);
    },
  },
});
